import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Avatar,
  Breadcrumb,
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  List,
  Modal,
  message,
  notification,
  Radio,
  Skeleton,
  Switch,
  Table,
} from 'antd';
import { EyeOutlined, BookOutlined, UploadOutlined } from '@ant-design/icons';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import _ from 'lodash';
import moment from 'moment';
import Errors from 'validatorjs/src/errors';

import styles from './styles.module.scss';
import whttp from 'libs/whttp';
import AppHelper from 'libs/AppHelper';
import { genFormItemAtrribute } from 'libs/FormHelper';
import { API_HOST } from 'configs/env';
import WUpload from 'components/WUpload/WUpload';
import DeleteConfirmButton from 'components/DeleteConfirmButton/DeleteConfirmButton';
import ValidatorErrorAlert from 'components/ValidatorErrorAlert/ValidatorErrorAlert';

const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };

@DragDropContext(HTML5Backend)
export default class CatalogueInfo extends Component {
  formRef = React.createRef();

  state = {
    catalogueInfo: {
      id: null,
      status: 1,
      name: null,
      logo: null,
      type: 1,
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
    isEDMType: false
  };

  componentDidMount() {
    AppHelper.updateConfig();
    this.fetchData();
    this.fillData();
  }

  fillData = (data = {}) => {
    if (!this.formRef.current) return;

    // 處理資料，本地適合Form Control的資料
    if (!_.isString(data.cover)) {
      data.cover = null;
    } else {
      data.cover = {
        id: 1,
        path: data.cover,
        url: data.cover_url,
      };
    }
    data.show_range = [
      _.get(data, 'show_at') ? moment(_.get(data, 'show_at')) : null,
      _.get(data, 'show_at') ? moment(_.get(data, 'hide_at')) : null,
    ];
    data.promotion_date_range = [
      moment(_.get(data, 'promotion_start_date')),
      moment(_.get(data, 'promotion_end_date')),
    ];

    if (!_.isBoolean(data.status)) data.status = data.status === 1;

    this.formRef.current.setFieldsValue(data);
    setTimeout(() => {
      this.isEdmCategory()
    }, 500);
  };

  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/mgt/v1/catalogues/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/catalogues');
        return;
      }

      this.fillData(data);
    });
  };

  submitData = (catalogueInfo = {}) => {
    window.cc = this.formRef.current;
    // 把Control元件轉換回上傳資料
    catalogueInfo.cover = _.get(catalogueInfo, 'cover.path');
    catalogueInfo.show_at = _.get(catalogueInfo, 'show_range.0').format(
      'YYYY-MM-DD HH:mm:ss'
    );
    catalogueInfo.hide_at = _.get(catalogueInfo, 'show_range.1').format(
      'YYYY-MM-DD HH:mm:ss'
    );
    catalogueInfo.promotion_start_date = _.get(
      catalogueInfo,
      'promotion_date_range.0'
    ).format('YYYY-MM-DD');
    catalogueInfo.promotion_end_date = _.get(
      catalogueInfo,
      'promotion_date_range.1'
    ).format('YYYY-MM-DD');

    delete catalogueInfo.show_range;
    delete catalogueInfo.promotio_date_range;

    const current_user = _.get(window, 'VC_CONFIG.WP_CURRENT_USER', '');
    catalogueInfo.user_id = current_user.ID;
    const id = _.get(this, 'props.match.params.id', '');

    // 不是edm類別，清空iframe_url
    if(!this.state.isEDMType)
      catalogueInfo.iframe_url = ''

    this.setState({ isSubmitData: true, messages: {} });

    whttp.post(
      API_HOST + `/api/mgt/v1/catalogues/${id}`,
      catalogueInfo,
      (state, res) => {
        this.setState({ isSubmitData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          notification['error']({
            message: '更新失敗',
            description: reason,
          });
          const messages = data.messages;
          if (_.isObject(messages)) {
            //處理錯誤訊息
            _.map(messages, (errors, key) => {
              return {
                touched: true,
                validating: false,
                errors: [],
                name: [key],
                value: this.getFieldValue(key),
              };
            });
            this.forceUpdate();
          }
          return this.setState({ messages: data.messages || {} });
        }

        const { data: { id: new_id } = {} } = res;

        if (new_id != id) {
          message.success('新增成功');
          this.setState({ catalogueInfo: data });

          return this.props.history.replace(`/catalogues/view/${new_id}`);
        }

        message.success('更新成功');
      }
    );
  };

  deleteUser = (e) => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isDeleteUser: true });
    whttp.delete(
      API_HOST + `/api/mgt/v1/catalogues/${id}`,
      {},
      (state, res) => {
        this.setState({ isDeleteUser: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          return message.error(reason);
        }

        notification['success']({
          message: '刪除成功',
        });

        return this.props.history.replace(`/catalogues`);
      }
    );
  };

  getImages = () => {
    return this.formRef.current &&
      _.isArray(this.formRef.current.getFieldValue('images'))
      ? this.formRef.current.getFieldValue('images')
      : [];
  };

  moveRow = (dragIndex, hoverIndex) => {
    const { table_data = {}, table_data: { rows = [] } = {} } = this.state;
    let images = this.getImages();
    const dragRow = images[dragIndex];

    images = update(images, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
    });

    this.formRef.current.setFields([
      {
        touched: true,
        validating: false,
        errors: [],
        name: ['images'],
        value: images,
      },
    ]);
  };

  getFieldValue = (key, defaultValue = undefined) => {
    return this.formRef.current
      ? this.formRef.current.getFieldValue(key)
      : defaultValue;
  };

  enterNotSubmit = (e) => {
    if (e.key === 'Enter') {
      let value = e.target + '';
      if (value.indexOf('TextArea') !== -1) {
        console.log('TextArea');
      } else e.preventDefault();
    }
  };

  isEdmCategory = () => {
    if(!this.formRef.current) return false
    const options = _.get(this, 'props.app.options', {});
    const edmCate = _.get(options, 'catalogue_categories', []).find(c => c.name === '電子目錄')
    // if edmCate not found return undefined, else return edmCate.id
    const cateId = this.formRef.current.getFieldValue('category_id') || ''
    this.setState({isEDMType: edmCate ? edmCate.id === cateId : false})
  }

  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors());
    const options = _.get(this, 'props.app.options', {});
    const id = this.getFieldValue('id');

    return (
      <Layout className={styles.container}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/catalogues`}>促銷目錄管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>促銷目錄資訊</Breadcrumb.Item>
        </Breadcrumb>
        <h2>促銷目錄資訊</h2>
        <ValidatorErrorAlert errors={errors} />
        <Skeleton loading={this.state.isFetchData}>
          <div className='block search'>
            <Form
              ref={this.formRef}
              name='basic'
              className='basicForm'
              layout='vertical'
              onFinish={(values) => this.submitData(values)}
              onKeyDown={(e) => this.enterNotSubmit(e)}
            >
              {!this.state.isEDMType && (
                <div>
                 <Form.Item
                 style={{ textAlign: 'left' }}
                 taillayout={{ wrapperCol: { offset: 8, span: 16 } }}
                  >
                    <a
                      href={`${
                        window.VC_CONFIG.INDEX_URL
                      }/wp-content/themes/cec/assets/file/catalogues/promotion_sample-2.zip`}
                      target='_blank'
                    >
                      {' '}
                      <Button> ZIP範例 </Button>
                    </a>
                    <a
                      href={`${
                        window.VC_CONFIG.INDEX_URL
                      }/wp-content/themes/cec/assets/file/catalogues/DM-sample.xlsx`}
                      target='_blank'
                    >
                      {' '}
                      <Button> Excel範例 </Button>
                    </a>
                  </Form.Item>
                  <span>
                    PDF、Excel需使用FTP上傳，如需變更檔案
                    <br />
                    請把PDF命名為「update_pdf_{id}.pdf」，把Excel命名為
                    「update_excel_{id}.xlsx」
                  </span>
                </div>
              )}
              <Form.Item
                style={{ textAlign: 'right' }}
                taillayout={{ wrapperCol: { offset: 8, span: 16 } }}
              >
                <Button
                  type='primary'
                  htmlType='submit'
                  style={{ marginLeft: 8 }}
                  loading={this.state.isSubmitData}
                >
                  儲存
                </Button>
              </Form.Item>
              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('name', '名稱')}
                  rules={[{ required: true, message: '請填寫名稱' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('en_name', '英文名稱')}
                  rules={[{ required: true, message: '請填寫英文名稱' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item {...genFormItemAtrribute('sort', '排序')}>
                  <InputNumber style={{ width: '100%' }} min={0} />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('status', '狀態', 'checked')}
                >
                  <Switch checkedChildren='啟用' unCheckedChildren='停用' />
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('show_range', '系統上下架時間')}
                  extra='系統於該時段顯示於官網，注意狀態需為「啟用」。'
                  rules={[{ required: true, message: '請填寫系統上下架時間' }]}
                >
                  <DatePicker.RangePicker
                    showTime={{
                      defaultValue: [
                        moment('09:00:00', 'HH:mm:ss'),
                        moment('23:59:59', 'HH:mm:ss'),
                      ],
                      format: 'HH:mm',
                    }}
                    format='YYYY-MM-DD HH:mm'
                  />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute(
                    'promotion_date_range',
                    '促銷活動日期'
                  )}
                  rules={[{ required: true, message: '請填寫促銷活動日期' }]}
                >
                  <DatePicker.RangePicker />
                </Form.Item>
              </div>
              <Form.Item
                {...genFormItemAtrribute('category_id', '目錄類別')}
                rules={[{ required: true, message: '請選擇目錄類別' }]}

              >
                <Radio.Group
                  onChange={this.isEdmCategory}>
                  <List
                    grid={listGrid}
                    dataSource={_.get(options, 'catalogue_categories', [])}
                    renderItem={(item) => (
                      <List.Item>
                        <Radio value={item.id}>{item.name}</Radio>
                      </List.Item>
                    )}
                  />
                </Radio.Group>
              </Form.Item>
              <Form.Item
                  {...genFormItemAtrribute('specialized', '超市專屬', 'checked')}
                  >
                    <Switch checkedChildren='啟用' unCheckedChildren='停用' />
                </Form.Item>
              <div className='flexBox'>
                <Form.Item {...genFormItemAtrribute('desc', '促銷目錄說明')}>
                  <Input.TextArea rows={10} />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('en_desc', '英文促銷目錄說明')}
                >
                  <Input.TextArea rows={10} />
                </Form.Item>
              </div>
              <div className='flexBox'>
                {
                  this.state.isEDMType && (
                    <Form.Item
                      {...genFormItemAtrribute('iframe_url', '電子目錄網址')}>
                      <Input />
                    </Form.Item>
                  )
                }
              </div>
              <Divider>目錄檔案管理</Divider>
              <span>此區塊操作後還需按下上方的「儲存」資料方得保留</span>
              <div className='flexBox'>
                <Form.Item label='封面' style={{ minHeight: 166 }}>
                  <Form.List name='images'>
                    {() => {
                      const url = _.get(this.getFieldValue('images'), '0.url');
                      return (
                        <Avatar
                          shape='square'
                          size={128}
                          style={{ height: 166 }}
                          icon={<BookOutlined />}
                          src={url}
                        />
                      );
                    }}
                  </Form.List>
                </Form.Item>

                {!this.state.isEDMType && (
                  <Form.Item label='PDF檔案'>
                    <Form.List name='pdfs'>
                      {(fields, { add, remove, move }) => {
                        if (fields.length === 0)
                          return (
                            <Button type='dashed' disabled>
                              {' '}
                              檔案需透過FTP上傳{' '}
                            </Button>
                          );
                        const url = _.get(this.getFieldValue('pdfs'), '0.url');
                        return (
                          <Fragment>
                            <Button danger onClick={() => remove(0)}>
                              {' '}
                              刪除{' '}
                            </Button>
                            <a href={url} target='_blank'>
                              {' '}
                              <Button> PDF下載 </Button>
                            </a>
                          </Fragment>
                        );
                      }}
                    </Form.List>
                </Form.Item>
              )}
                
              </div>
              <Form.Item>
                <Form.Item
                  {...genFormItemAtrribute(
                    'images',
                    '圖片上傳 寬140x高210 (2:3)'
                  )}
                  valuePropName='fileList'
                  extra='第一張圖片為封面，建議尺寸: 寬140x高210 (2:3)'
                >
                  <WUpload multiple={true} showUploadList={false}>
                    <Button>
                      <UploadOutlined /> 上傳
                    </Button>
                  </WUpload>
                </Form.Item>
                <Form.List name='images'>
                  {(fields, { add, remove, move }) => (
                    <div>
                      <Table
                        dataSource={this.getFieldValue('images')}
                        loading={this.state.isLoadingData}
                        pagination={false}
                        rowKey='id'
                        components={{
                          body: {
                            row: DragableBodyRow,
                          },
                        }}
                        onRow={(record, index) => ({
                          index,
                          moveRow: (dragIndex, hoverIndex) =>
                            move(dragIndex, hoverIndex),
                        })}
                        columns={[
                          { dataIndex: 'id', title: '#' },
                          {
                            dataIndex: 'url',
                            title: '圖片',
                            render: (
                              url,
                              asset //${url.replace(/\s/g, encodeURIComponent(' '))}
                            ) => (
                              <div
                                className='tableImg'
                                style={{
                                  backgroundImage: `url(${_.split(
                                    url,
                                    ' '
                                  ).join(encodeURIComponent(' '))})`,
                                }}
                                alt='avatar'
                              />
                            ),
                          },
                          {
                            dataIndex: 'name',
                            title: '名稱',
                            render: (name, item) =>
                              this.getFieldValue('images').indexOf(item) === 0
                                ? `[封面] ${name}`
                                : name,
                          },
                          {
                            title: 'Action',
                            dataIndex: 'id',
                            key: 'tools',
                            width: 250,
                            render: (id, record) => (
                              <List
                                grid={{ gutter: 4, column: 3 }}
                                dataSource={[
                                  <DeleteConfirmButton
                                    loading={record.isDeleteData === true}
                                    size='small'
                                    onConfirm={() => {
                                      let images = this.getFieldValue('images');

                                      remove(images.indexOf(record));
                                    }}
                                  />,
                                  <Button
                                    type='default'
                                    size='small'
                                    icon={<EyeOutlined />}
                                    onClick={() =>
                                      this.setState({
                                        previewImage: { url: record.url },
                                      })
                                    }
                                  >
                                    檢視
                                  </Button>,
                                ]}
                                renderItem={(item) => (
                                  <List.Item>{item}</List.Item>
                                )}
                              />
                            ),
                          },
                        ]}
                      />
                    </div>
                  )}
                </Form.List>
              </Form.Item>
              {!this.state.isEDMType && (
                <div>
                  <Divider>目錄索引區塊</Divider>
                  <Form.List name='category_indexes'>
                    {(fields, { add, remove, move }) => {
                      return (
                        <Fragment>
                          {fields.length > 0 && (
                            <Table
                              pagination={false}
                              rowKey={(item, idx) => idx}
                              dataSource={fields}
                              columns={[
                                {
                                  dataIndex: 'id',
                                  title: '#',
                                  render: (id, item, idx) => idx + 1,
                                },
                                {
                                  dataIndex: 'page',
                                  title: '頁數',
                                  render: (page, item, idx) => {
                                    return (
                                      <Form.Item
                                        {...genFormItemAtrribute([idx, 'page'])}
                                        rules={[
                                          {
                                            required: true,
                                            message: '必填',
                                          },
                                        ]}
                                      >
                                        <Input />
                                      </Form.Item>
                                    );
                                  },
                                },
                                {
                                  dataIndex: 'index_name',
                                  title: '索引名稱',
                                  render: (indexName, item, idx) => {
                                    return (
                                      <Form.Item
                                        {...genFormItemAtrribute([
                                          idx,
                                          'index_name',
                                        ])}
                                        rules={[
                                          {
                                            required: true,
                                            message: '必填',
                                          },
                                        ]}
                                      >
                                        <Input />
                                      </Form.Item>
                                    );
                                  },
                                },
                                {
                                  dataIndex: 'action',
                                  title: 'Action',
                                  render: (name, item, idx) => (
                                    <Form.Item>
                                      <Button danger onClick={() => remove(idx)}>
                                        刪除
                                      </Button>
                                    </Form.Item>
                                  ),
                                },
                              ]}
                            />
                          )}
                          <Form.Item>
                            <Button htmlType='button' onClick={() => add()}>
                              新增
                            </Button>
                          </Form.Item>
                        </Fragment>
                      );
                    }}
                  </Form.List>
                </div>
              )}
            </Form>
          </div>
          <Modal
            visible={this.state.previewImage}
            footer={null}
            onCancel={() => this.setState({ previewImage: null })}
          >
            <img
              alt='Preview'
              style={{ width: '100%' }}
              src={this.state.previewImage && this.state.previewImage.url}
            />
          </Modal>
        </Skeleton>
      </Layout>
    );
  }
}

/* DnD */
let dragingIndex = -1;

class BodyRow extends React.Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: 'move' };

    let className = restProps.className;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward';
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward';
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />
      )
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, (connect) => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow)
);

/* DnD */



// WEBPACK FOOTER //
// ./src/views/Catalogue/CatalogueInfo.js